var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileweb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3034 15.3335H10.3034C9.72875 15.3335 9.17765 15.5825 8.77132 16.0258C8.36499 16.4691 8.13672 17.0703 8.13672 17.6971V32.6668H25.4701V17.6971C25.4701 17.0703 25.2418 16.4691 24.8355 16.0258C24.4291 15.5825 23.878 15.3335 23.3034 15.3335ZM10.3034 16.9093H23.3034C23.4949 16.9093 23.6786 16.9923 23.8141 17.14C23.9495 17.2878 24.0256 17.4882 24.0256 17.6971V20.0608H9.58116V17.6971C9.58116 17.4882 9.65725 17.2878 9.7927 17.14C9.92814 16.9923 10.1118 16.9093 10.3034 16.9093ZM9.58116 31.0911V21.6365H24.0256V31.0911H9.58116Z",
    fill: "#FEF335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4702 15.4556V30.4081C28.4702 30.9747 28.6953 31.518 29.0959 31.9186C29.4965 32.3192 30.0398 32.5442 30.6063 32.5442H37.7266C38.2931 32.5442 38.8364 32.3192 39.237 31.9186C39.6376 31.518 39.8626 30.9747 39.8626 30.4081V15.4556H28.4702ZM38.4386 16.8796V26.848H29.8943V16.8796H38.4386ZM37.7266 31.1202H30.6063C30.4175 31.1202 30.2363 31.0451 30.1028 30.9116C29.9693 30.7781 29.8943 30.597 29.8943 30.4081V28.2721H38.4386V30.4081C38.4386 30.597 38.3636 30.7781 38.23 30.9116C38.0965 31.0451 37.9154 31.1202 37.7266 31.1202Z",
    fill: "#FEF335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileweb);
export default __webpack_public_path__ + "static/media/mobile&web.fb2170a7ed34435872925e413e4e6833.svg";
export { ForwardRef as ReactComponent };